import { useTranslation } from "react-i18next";
import Button from "../../button/Button";
import AcedModal from "../aced-modal/AcedModal";
import "./ConfirmationModal.scss";

export interface ConfirmationModalProps {
	title: string;
	state: {
		isModalOpen: any;
		setModalOpen: any;
	};
	onConfirm: any;
}

const ConfirmationModal = ({
	title,
	state,
	onConfirm,
}: ConfirmationModalProps) => {
	const { t } = useTranslation();

	if (!state.isModalOpen) return null;

	return (
		<AcedModal
			state={state}
			title={title}
			className="confirmation-modal"
		>
			<div className="delete-modal">
				<div className="options">
					<Button
						className="btn btn-primary"
						action={onConfirm}
					>
						{t("common.words.yes")}
					</Button>
					<Button
						className="btn btn-primary"
						action={() => {
							state.setModalOpen(false);
						}}
					>
						{t("common.words.no")}
					</Button>
				</div>
			</div>
		</AcedModal>
	);
};

export default ConfirmationModal;
